// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Popup anchored to the wrapper (renders as a dropdown) */
.conversation-history-popup {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: var(--z-index-popup);
  width: 420px;
  max-width: 90vw;
  /* Responsive adjustments for smaller screens */
}
@media screen and (max-width: 768px) {
  .conversation-history-popup {
    position: fixed;
    top: 70px;
    right: 10px;
    left: 10px;
    width: auto;
    max-width: none;
  }
}
@media screen and (max-width: 480px) {
  .conversation-history-popup {
    top: 60px;
    right: 5px;
    left: 5px;
  }
}

/* Card box (dropdown card) */
.conversation-history-popup-box {
  background: var(--primary-color-light-500);
  color: var(--primary-color-500);
  border-radius: 8px;
  /* use design tokens for shadow so it adapts to theme */
  box-shadow: 0 6px 18px rgba(2, 6, 23, 0.18);
  box-shadow: 0 6px 18px var(--box-shadow-primary-18, rgba(2, 6, 23, 0.18));
  overflow: auto;
  padding: 0.5rem;
  max-height: 60vh;
}

.conversation-history-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid var(--rs-gray-200, rgba(0, 0, 0, 0.06));
}

.conversation-history {
  flex: 1 1 auto;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  color: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.history__date {
  flex: 0 0 auto;
  color: rgba(0, 0, 0, 0.5);
  color: var(--rs-gray-600, rgba(0, 0, 0, 0.5));
  font-size: 0.85rem;
  min-width: 6.5rem;
  text-align: right;
}

.history__delete {
  color: rgba(0, 0, 0, 0.45);
  color: var(--rs-gray-500, rgba(0, 0, 0, 0.45));
  cursor: pointer;
  margin-left: 0.5rem;
}

/* Loading spinner */
.conversation-history-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
}

.conversation-history-loading__label {
  margin-top: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  color: var(--rs-gray-600, rgba(0, 0, 0, 0.6));
  font-size: 0.95rem;
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/ConversationHistory/ConversationHistory.component.scss"],"names":[],"mappings":"AACA,0DAAA;AACA;EACC,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EAEA,+CAAA;AADD;AAEC;EATD;IAUE,eAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;EACA;AACF;AACC;EAlBD;IAmBE,SAAA;IACA,UAAA;IACA,SAAA;EAEA;AACF;;AACA,6BAAA;AACA;EACC,0CAAA;EACA,+BAAA;EACA,kBAAA;EACG,uDAAA;EACA,2CAAA;EAAA,yEAAA;EACH,cAAA;EACA,eAAA;EACA,gBAAA;AAED;;AACA;EACC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACG,4CAAA;EAAA,gEAAA;AAEJ;;AACA;EACC,cAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAED;;AACA;EACC,cAAA;EACG,yBAAA;EAAA,6CAAA;EACH,kBAAA;EACA,iBAAA;EACA,iBAAA;AAED;;AACA;EACI,0BAAA;EAAA,8CAAA;EACH,eAAA;EACA,mBAAA;AAED;;AACA,oBAAA;AACA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAED;;AACA;EACC,mBAAA;EACG,yBAAA;EAAA,6CAAA;EACH,kBAAA;AAED","sourcesContent":["\n/* Popup anchored to the wrapper (renders as a dropdown) */\n.conversation-history-popup {\n\tposition: absolute;\n\ttop: calc(100% + 8px);\n\tright: 0;\n\tz-index: var(--z-index-popup);\n\twidth: 420px;\n\tmax-width: 90vw;\n\n\t/* Responsive adjustments for smaller screens */\n\t@media screen and (max-width: 768px) {\n\t\tposition: fixed;\n\t\ttop: 70px;\n\t\tright: 10px;\n\t\tleft: 10px;\n\t\twidth: auto;\n\t\tmax-width: none;\n\t}\n\n\t@media screen and (max-width: 480px) {\n\t\ttop: 60px;\n\t\tright: 5px;\n\t\tleft: 5px;\n\t}\n}\n\n/* Card box (dropdown card) */\n.conversation-history-popup-box {\n\tbackground: var(--primary-color-light-500);\n\tcolor: var(--primary-color-500);\n\tborder-radius: 8px;\n    /* use design tokens for shadow so it adapts to theme */\n    box-shadow: 0 6px 18px var(--box-shadow-primary-18, rgba(2,6,23,0.18));\n\toverflow: auto;\n\tpadding: 0.5rem;\n\tmax-height: 60vh;\n}\n\n.conversation-history-item {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.75rem;\n\tpadding: 0.5rem 0.25rem;\n    border-bottom: 1px solid var(--rs-gray-200, rgba(0,0,0,0.06));\n}\n\n.conversation-history {\n\tflex: 1 1 auto;\n\tcursor: pointer;\n\tpadding: 0.25rem 0.5rem;\n\tborder-radius: 4px;\n\tcolor: inherit;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.history__date {\n\tflex: 0 0 auto;\n    color: var(--rs-gray-600, rgba(0,0,0,0.5));\n\tfont-size: 0.85rem;\n\tmin-width: 6.5rem;\n\ttext-align: right;\n}\n\n.history__delete {\n    color: var(--rs-gray-500, rgba(0,0,0,0.45));\n\tcursor: pointer;\n\tmargin-left: 0.5rem;\n}\n\n/* Loading spinner */\n.conversation-history-loading {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 2rem 0;\n}\n\n.conversation-history-loading__label {\n\tmargin-top: 0.75rem;\n    color: var(--rs-gray-600, rgba(0,0,0,0.6));\n\tfont-size: 0.95rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
